import { push } from 'redux-first-history';
import { getUrlString, updateSearchObject } from '../../../utils/shared/urlUtils';
import {
    SAVE_BASIC_COMPREHENSION_RESULT,
    INVALIDATE_BASIC_COMPREHENSION_RESULT,
    CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA,
    UPDATE_ROW_STATUS_OBJECT,
} from '../../actionTypes/shared/apiActionTypes';
import { hasAllData } from '../../../components/webEntryPanel/validation';
import { apiActionCreator } from '../../actionCreators';
import selectors from '../../../root/shared/root';
import { TIME_TO_WAIT_FOR_INVALIDATE } from '../../../constants/shared/WebEntryConstants';

export const openBasicComprehensionWebEntry = isEditable => async (dispatch, getState) => {
    const state = getState();
    const location = selectors.getLocation(state);
    dispatch(
        push(
            getUrlString(location.pathname, {
                ...updateSearchObject(location, [], {
                    webEntryOpened: true,
                    ...(isEditable && { isEditable }),
                }),
            }),
        ),
    );
};

export const invalidateResult =
    (studentId, resultId, client, basicComprehensionMeasure) => async dispatch => {
        const apiActionConfigObject = {
            apiParams: [resultId],
            additionalResponseParams: {
                studentId,
                resultId,
                basicComprehensionMeasure,
            },
            isNeededStartAction: false,
            preApiCallCalback: () => {
                dispatch({
                    type: INVALIDATE_BASIC_COMPREHENSION_RESULT.START,
                    studentId,
                });
            },
        };
        await apiActionCreator(
            dispatch,
            INVALIDATE_BASIC_COMPREHENSION_RESULT,
            client.deleteResult,
            apiActionConfigObject,
        );
    };

export const updateRowStatusObject = (studentId, statusObject) => ({
    type: UPDATE_ROW_STATUS_OBJECT,
    studentId,
    ...statusObject,
});

export const createResult = props => async (dispatch, getState) => {
    const state = getState();
    const { userId, year } = selectors.getCommonData(state);
    const {
        fields,
        studentId,
        grade,
        formId,
        period,
        getResult,
        client,
        temporalStudentId,
        temporalInstId,
    } = props;
    const { date, correctResponses, incorrectResponses, formNumber } = fields;
    // Datepicker doesn't return hours and minutes, but we need them to save result correctly
    const currentDate = new Date();
    date.setHours(currentDate.getHours());
    date.setMinutes(currentDate.getMinutes());
    date.setSeconds(currentDate.getSeconds());
    const dateString = `${date.toISOString().split('.').shift()}Z`;
    const apiActionConfigObject = {
        apiParams: [
            {
                date: dateString,
                correctResponses,
                incorrectResponses,
                schoolId: temporalInstId,
                staffId: userId,
                studentId,
                year,
                grade,
                period,
                formId,
                formNumber,
                temporalStudentId,
            },
        ],
        additionalResponseParams: {
            studentId,
            getResult,
        },
        isNeededStartAction: false,
        preApiCallCalback: () => {
            dispatch({ type: SAVE_BASIC_COMPREHENSION_RESULT.START, studentId });
        },
        afterApiCallCalback: () => {
            dispatch(
                updateRowStatusObject(studentId, {
                    isRowSaving: true,
                }),
            );
            setTimeout(() => {
                dispatch(
                    updateRowStatusObject(studentId, {
                        isRowDisabled: false,
                        isRowSaving: false,
                        isAlreadyCreated: true,
                    }),
                );
            }, TIME_TO_WAIT_FOR_INVALIDATE);
        },
    };
    await apiActionCreator(
        dispatch,
        SAVE_BASIC_COMPREHENSION_RESULT,
        client.createResult,
        apiActionConfigObject,
    );
};

export const clearBasicComprehensionWebEntryData = () => ({
    type: CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA,
});

export const prepareAndCreateResult = props => async dispatch => {
    const { studentId, fields, formId } = props;
    dispatch(updateRowStatusObject(studentId, { isRowDisabled: true }));
    if (hasAllData(Object.values(fields)) && formId) {
        await dispatch(createResult(props));
    }
};
